module.exports = __webpack_public_path__ + "img/erro-servidor.73d9e8e8.svg";